import React, { useMemo, useState } from "react";
import {
  Card,
  CardContent,
  Typography,
  Box,
  Tabs,
  Tab,
  IconButton,
  Collapse,
  Divider,
  Tooltip,
} from "@mui/material";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";

import "./AssistantCard.css";

import GeneralSettings from "./sections/GeneralSettings";
import KnowledgeSettings from "./sections/KnowledgeSettings";
import ToolsSettings from "./sections/ToolsSettings";
import GuardrailsSettings from "./sections/GuardrailsSettings";

import ChannelSettings from "./sections/ChannelSettings";

// const uniqLower = (arr) => {
//   const seen = new Set();
//   return arr
//     .map((x) => String(x || "").trim())
//     .filter(Boolean)
//     .filter((x) => {
//       const k = x.toLowerCase();
//       if (seen.has(k)) return false;
//       seen.add(k);
//       return true;
//     });
// };


/**
 * Guardrails, structured UI + advanced JSON editor
 * Stores JSON on assistant.guardrails
 */
// function GuardrailsSettings({ assistant, onUpdate }) {
//   const assistantId = assistant?.id ?? assistant?.assistant_id ?? assistant?._id ?? null;

//   const [saved, setSaved] = useState(false);
//   const [localError, setLocalError] = useState("");
//   const [advancedOpen, setAdvancedOpen] = useState(false);

//   const [guardrails, setGuardrails] = useState(() => {
//     const g = assistant?.guardrails ?? {};
//     return {
//       policy: g.policy || "balanced", // strict | balanced | custom
//       piiProtection: g.piiProtection ?? true,
//       requireCitations: g.requireCitations ?? false,
//       ...g,
//       blockedTopics: safeArray(g.blockedTopics),
//       blockedPhrases: safeArray(g.blockedPhrases),
//       allowedDomains: safeArray(g.allowedDomains),
//     };
//   });

//   const [topicInput, setTopicInput] = useState("");
//   const [phraseInput, setPhraseInput] = useState("");
//   const [domainInput, setDomainInput] = useState("");

//   const [jsonDraft, setJsonDraft] = useState(() => JSON.stringify(guardrails, null, 2));
//   useEffect(() => {
//     if (!advancedOpen) setJsonDraft(JSON.stringify(guardrails, null, 2));
//   }, [guardrails, advancedOpen]);

//   const setField = (key, value) => setGuardrails((prev) => ({ ...prev, [key]: value }));

//   const addToList = (key, value) => {
//     const clean = String(value || "").trim();
//     if (!clean) return;

//     setGuardrails((prev) => ({
//       ...prev,
//       [key]: uniqLower([...(safeArray(prev[key])), clean]),
//     }));
//   };

//   const removeFromList = (key, value) => {
//     const lower = String(value || "").trim().toLowerCase();
//     setGuardrails((prev) => ({
//       ...prev,
//       [key]: safeArray(prev[key]).filter((x) => String(x || "").trim().toLowerCase() !== lower),
//     }));
//   };

//   const applyPreset = (policy) => {
//     // UI defaults (you can tune later)
//     if (policy === "strict") {
//       setGuardrails((prev) => ({
//         ...prev,
//         policy: "strict",
//         piiProtection: true,
//         requireCitations: false,
//         blockedTopics: uniqLower([...(safeArray(prev.blockedTopics)), "self-harm", "hate", "illegal instructions"]),
//       }));
//       return;
//     }
//     if (policy === "balanced") {
//       setGuardrails((prev) => ({
//         ...prev,
//         policy: "balanced",
//         piiProtection: true,
//       }));
//       return;
//     }
//     setGuardrails((prev) => ({ ...prev, policy: "custom" }));
//   };

//   const handleApplyJson = () => {
//     setLocalError("");
//     try {
//       const parsed = jsonDraft?.trim() ? JSON.parse(jsonDraft) : {};
//       setGuardrails({
//         policy: parsed.policy || "balanced",
//         piiProtection: parsed.piiProtection ?? true,
//         requireCitations: parsed.requireCitations ?? false,
//         ...parsed,
//         blockedTopics: safeArray(parsed.blockedTopics),
//         blockedPhrases: safeArray(parsed.blockedPhrases),
//         allowedDomains: safeArray(parsed.allowedDomains),
//       });
//     } catch (e) {
//       setLocalError("Invalid JSON. Fix formatting, then try Apply.");
//     }
//   };

//   const handleSave = () => {
//     setSaved(false);
//     setLocalError("");

//     if (typeof onUpdate !== "function") return;

//     if (onUpdate.length >= 2 && assistantId != null) {
//       onUpdate(assistantId, { guardrails });
//     } else {
//       onUpdate({ ...assistant, guardrails });
//     }

//     setSaved(true);
//   };

//   return (
//     <Box className="assistantCardSection">
//       <Box className="assistantCardStatusStack">
//         {localError ? <Alert severity="error">{localError}</Alert> : null}
//         {saved ? <Alert severity="success">Saved successfully.</Alert> : null}
//       </Box>

//       {/* Preset + toggles */}
//       <Box className="assistantCardSubCard">
//         <Typography className="assistantCardSubTitle">Policy</Typography>

//         <Box className="assistantCardGrid2">
//           <FormControl fullWidth>
//             <InputLabel id="guardrails-policy">Preset</InputLabel>
//             <Select
//               labelId="guardrails-policy"
//               value={guardrails.policy || "balanced"}
//               label="Preset"
//               onChange={(e) => applyPreset(e.target.value)}
//             >
//               <MenuItem value="strict">Strict</MenuItem>
//               <MenuItem value="balanced">Balanced</MenuItem>
//               <MenuItem value="custom">Custom</MenuItem>
//             </Select>
//           </FormControl>

//           <Box className="assistantCardSwitchGrid">
//             <FormControlLabel
//               className="assistantSwitch"
//               control={
//                 <Switch
//                   checked={!!guardrails.piiProtection}
//                   onChange={(e) => setField("piiProtection", e.target.checked)}
//                 />
//               }
//               label="PII protection"
//             />
//             <FormControlLabel
//               className="assistantSwitch"
//               control={
//                 <Switch
//                   checked={!!guardrails.requireCitations}
//                   onChange={(e) => setField("requireCitations", e.target.checked)}
//                 />
//               }
//               label="Require citations"
//             />
//           </Box>
//         </Box>

//         <Box className="assistantCardHintBox" style={{ marginTop: 12 }}>
//           <Typography className="assistantCardHintTitle">Tip</Typography>
//           <Typography className="assistantCardHintText">
//             Use “Strict” for high-risk domains (compliance/support). Keep “Custom” if you’re tuning topic/phrase rules.
//           </Typography>
//         </Box>
//       </Box>

//       {/* Blocked topics */}
//       <Box className="assistantCardSubCard">
//         <Typography className="assistantCardSubTitle">Blocked topics</Typography>

//         <Box className="assistantInlineAddRow">
//           <TextField
//             size="small"
//             label="Add a topic"
//             value={topicInput}
//             onChange={(e) => setTopicInput(e.target.value)}
//             placeholder="e.g. medical advice"
//             fullWidth
//           />
//           <Button
//             variant="outlined"
//             className="assistantSecondaryButton"
//             onClick={() => {
//               addToList("blockedTopics", topicInput);
//               setTopicInput("");
//             }}
//           >
//             Add
//           </Button>
//         </Box>

//         <Stack direction="row" flexWrap="wrap" gap={1} className="assistantChipGrid">
//           {safeArray(guardrails.blockedTopics).length === 0 ? (
//             <Box className="assistantCardEmpty">No blocked topics.</Box>
//           ) : (
//             safeArray(guardrails.blockedTopics).map((t) => (
//               <Chip
//                 key={t}
//                 label={t}
//                 onDelete={() => removeFromList("blockedTopics", t)}
//                 className="assistantTopicChip"
//                 variant="outlined"
//               />
//             ))
//           )}
//         </Stack>
//       </Box>

//       {/* Blocked phrases */}
//       <Box className="assistantCardSubCard">
//         <Typography className="assistantCardSubTitle">Blocked phrases</Typography>

//         <Box className="assistantInlineAddRow">
//           <TextField
//             size="small"
//             label="Add a phrase"
//             value={phraseInput}
//             onChange={(e) => setPhraseInput(e.target.value)}
//             placeholder="e.g. “ignore previous instructions”"
//             fullWidth
//           />
//           <Button
//             variant="outlined"
//             className="assistantSecondaryButton"
//             onClick={() => {
//               addToList("blockedPhrases", phraseInput);
//               setPhraseInput("");
//             }}
//           >
//             Add
//           </Button>
//         </Box>

//         <Stack direction="row" flexWrap="wrap" gap={1} className="assistantChipGrid">
//           {safeArray(guardrails.blockedPhrases).length === 0 ? (
//             <Box className="assistantCardEmpty">No blocked phrases.</Box>
//           ) : (
//             safeArray(guardrails.blockedPhrases).map((p) => (
//               <Chip
//                 key={p}
//                 label={p}
//                 onDelete={() => removeFromList("blockedPhrases", p)}
//                 className="assistantPhraseChip"
//                 variant="outlined"
//               />
//             ))
//           )}
//         </Stack>
//       </Box>

//       {/* Allowed domains */}
//       <Box className="assistantCardSubCard">
//         <Typography className="assistantCardSubTitle">Allowed domains (optional)</Typography>
//         <Typography className="assistantCardHelpText" style={{ marginTop: 0 }}>
//           If you plan to restrict browsing/tools later, keep a domain allowlist here for your backend to enforce.
//         </Typography>

//         <Box className="assistantInlineAddRow">
//           <TextField
//             size="small"
//             label="Add a domain"
//             value={domainInput}
//             onChange={(e) => setDomainInput(e.target.value)}
//             placeholder="example.com"
//             fullWidth
//           />
//           <Button
//             variant="outlined"
//             className="assistantSecondaryButton"
//             onClick={() => {
//               addToList("allowedDomains", domainInput);
//               setDomainInput("");
//             }}
//           >
//             Add
//           </Button>
//         </Box>

//         <Stack direction="row" flexWrap="wrap" gap={1} className="assistantChipGrid">
//           {safeArray(guardrails.allowedDomains).length === 0 ? (
//             <Box className="assistantCardEmpty">No allowlisted domains.</Box>
//           ) : (
//             safeArray(guardrails.allowedDomains).map((d) => (
//               <Chip
//                 key={d}
//                 label={d}
//                 onDelete={() => removeFromList("allowedDomains", d)}
//                 className="assistantTopicChip"
//                 variant="outlined"
//               />
//             ))
//           )}
//         </Stack>
//       </Box>

//       {/* Advanced JSON */}
//       <Box className="assistantCardSubCard assistantCardSubCardMuted">
//         <Box className="assistantCardSectionHeaderRow">
//           <Typography className="assistantCardMiniTitle" style={{ margin: 0 }}>
//             Advanced JSON
//           </Typography>
//           <Button
//             variant="text"
//             className="assistantLinkButton"
//             startIcon={<CodeIcon />}
//             onClick={() => setAdvancedOpen((v) => !v)}
//           >
//             {advancedOpen ? "Hide" : "Edit JSON"}
//           </Button>
//         </Box>

//         <Collapse in={advancedOpen} timeout="auto" unmountOnExit>
//           <TextField
//             value={jsonDraft}
//             onChange={(e) => setJsonDraft(e.target.value)}
//             multiline
//             minRows={10}
//             fullWidth
//             className="assistantCardTextArea"
//             placeholder='{\n  "policy": "balanced",\n  "blockedTopics": [],\n  "blockedPhrases": [],\n  "allowedDomains": []\n}'
//           />

//           <Box className="assistantCardActions">
//             <Button
//               variant="outlined"
//               className="assistantSecondaryButton"
//               onClick={handleApplyJson}
//             >
//               Apply JSON
//             </Button>
//           </Box>
//         </Collapse>
//       </Box>

//       <Box className="assistantCardActions">
//         <Button
//           variant="contained"
//           onClick={handleSave}
//           className="assistantPrimaryButton"
//         >
//           Save Guardrails
//         </Button>
//       </Box>
//     </Box>
//   );
// }


// Channel keys map to human labels. BUSINESS is an internal config bucket
// rather than a channel the agent talks on, so it is excluded everywhere.
const CHANNEL_LABELS = {
  WEB: "Web",
  VAPI: "Phone",
  PHONE: "Phone",
  REALTIME: "Realtime",
};

const getChannelKeys = (assistant) =>
  Object.keys(assistant?.configs || {}).filter((k) => k !== "BUSINESS");

// Build a stable initials monogram from the agent name, matching the tool
// avatar approach on the Tools page.
const getInitials = (name) => {
  const words = String(name || "").trim().split(/\s+/).filter(Boolean);
  if (words.length === 0) return "?";
  if (words.length === 1) return words[0].slice(0, 2).toUpperCase();
  return (words[0][0] + words[words.length - 1][0]).toUpperCase();
};

const AssistantCard = ({ assistant, onUpdate, onDelete, defaultOpen = true }) => {
  const [currentTab, setCurrentTab] = useState(0);
  const [isOpen, setIsOpen] = useState(defaultOpen);

  const handleTabChange = (event, newValue) => setCurrentTab(newValue);

  const channelKeys = useMemo(() => getChannelKeys(assistant), [assistant]);

  const panelId = `assistant-panel-${assistant?.id}`;

  return (
    <Card className="assistantCard" variant="outlined">
      {/* The whole header is the expand control. Previously only a small icon
          button toggled the card, so most of the row looked clickable but did
          nothing. */}
      <CardContent
        className="assistantCardTop"
        onClick={() => setIsOpen((v) => !v)}
        role="button"
        tabIndex={0}
        aria-expanded={isOpen}
        aria-controls={panelId}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            setIsOpen((v) => !v);
          }
        }}
      >
        <Box className="assistantCardHeader">
          <Box className="assistantCardAvatar" aria-hidden="true">
            {getInitials(assistant?.name)}
          </Box>

          <Box className="assistantCardHeaderText">
            <Typography
              variant="h6"
              component="div"
              className="assistantCardTitle"
              title={assistant?.name}
            >
              {assistant?.name}
            </Typography>
          </Box>

          {/* Collapsed summary. The card used to show only a channel count,
              so the list gave no reason to expand one agent over another.
              Channel names are the metadata that actually differs between
              agents and changes how each one behaves.

              These sit as a sibling of the title rather than under it. The
              title is nowrap+ellipsis so it never consumes the row's surplus
              width; with the chips stacked beneath it, every extra pixel of
              page width became an empty band in the middle of the row. On one
              line the chips take up that slack and the row reads as full at
              any width. Below 600px they drop back under the name, see the
              media query in AssistantCard.css. */}
          <Box className="assistantCardMetaRow">
            {channelKeys.length === 0 ? (
              <span className="assistantCardChip assistantCardChip--empty">
                No channels
              </span>
            ) : (
              channelKeys.map((key) => (
                <span className="assistantCardChip" key={key}>
                  {CHANNEL_LABELS[key] || key}
                </span>
              ))
            )}
          </Box>

          <Box className="assistantCardHeaderActions">
            {/* Mobile-only delete. On desktop the delete button sits outside
                the card (see AssistantList), but at narrow widths that column
                steals space from the agent name, so it moves in here beside
                the chevron instead. Exactly one of the two is visible at any
                width, see .assistantCardDelete / .assistantListDeleteWrap. */}
            {onDelete && (
              <IconButton
                onClick={(e) => {
                  // The header is itself the expand control, so this must not
                  // bubble or deleting would also toggle the card.
                  e.stopPropagation();
                  onDelete(assistant.id);
                }}
                className="assistantCardDelete"
                size="small"
                aria-label={`Delete ${assistant?.name || "agent"}`}
                title="Delete agent"
              >
                <DeleteOutlineIcon fontSize="small" />
              </IconButton>
            )}

            <Tooltip title={isOpen ? "Collapse" : "Expand"}>
              <IconButton
                onClick={(e) => {
                  e.stopPropagation();
                  setIsOpen((v) => !v);
                }}
                className={`assistantCardExpand ${isOpen ? "expanded" : ""}`}
                size="small"
                aria-label={isOpen ? "collapse assistant" : "expand assistant"}
                aria-expanded={isOpen}
                aria-controls={panelId}
              >
                <ExpandMoreIcon />
              </IconButton>
            </Tooltip>
          </Box>
        </Box>
      </CardContent>

      <Collapse in={isOpen} timeout="auto" unmountOnExit id={panelId}>
        <Divider />

        <Box className="assistantCardTabsWrap">
          <Tabs
            value={currentTab}
            onChange={handleTabChange}
            aria-label="assistant settings tabs"
            variant="scrollable"
            scrollButtons="auto"
            allowScrollButtonsMobile
          >
            <Tab label="General" />
            <Tab label="Knowledge" />
            <Tab label="Tools" />
            <Tab label="Guardrails" />
            <Tab label="Channels" />
          </Tabs>
        </Box>

        <CardContent className="assistantCardBody">
          {currentTab === 0 && <GeneralSettings assistant={assistant} onUpdate={onUpdate} />}
          {currentTab === 1 && <KnowledgeSettings assistant={assistant} onUpdate={onUpdate} />}
          {currentTab === 2 && <ToolsSettings assistant={assistant} onUpdate={onUpdate} />}
          {currentTab === 3 && <GuardrailsSettings assistant={assistant} onUpdate={onUpdate} />}
          {currentTab === 4 && <ChannelSettings assistant={assistant} onUpdate={onUpdate} />}
        </CardContent>
      </Collapse>
    </Card>
  );
};

export default AssistantCard;
